import { emailService } from './emailService';

// Test invoice data for Emmanuel Sibanda
const testInvoiceData = {
  invoiceNumber: 'INV-2024-001',
  clientName: 'Emmanuel Sibanda',
  clientEmail: 'emmanuel@sibanda.africa',
  amount: 2500.00,
  dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days from now
  pdfUrl: 'https://c-band.com/invoice/INV-2024-001',
  companyName: 'C-Band Professional Services',
  companyEmail: 'accounts@c-band.com'
};

export async function sendTestInvoiceToEmmanuel() {
  try {
    console.log('Sending test invoice to Emmanuel Sibanda...');
    console.log('Invoice Details:', testInvoiceData);
    
    const result = await emailService.sendInvoiceEmail(testInvoiceData);
    
    if (result) {
      console.log('✅ Test invoice email sent successfully to emmanuel@sibanda.africa');
      console.log('📧 Email Details:');
      console.log(`   To: ${testInvoiceData.clientEmail}`);
      console.log(`   Subject: Invoice #${testInvoiceData.invoiceNumber} from ${testInvoiceData.companyName}`);
      console.log(`   Amount: R${testInvoiceData.amount.toFixed(2)}`);
      console.log(`   Due Date: ${new Date(testInvoiceData.dueDate).toLocaleDateString()}`);
      return true;
    } else {
      console.error('❌ Failed to send test invoice email');
      return false;
    }
  } catch (error) {
    console.error('❌ Error sending test invoice email:', error);
    return false;
  }
}

// Function to send a test payment reminder
export async function sendTestPaymentReminder() {
  try {
    const reminderData = {
      invoiceNumber: 'INV-2024-001',
      clientName: 'Emmanuel Sibanda',
      clientEmail: 'emmanuel@sibanda.africa',
      amount: 2500.00,
      dueDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), // 5 days ago
      daysOverdue: 5,
      companyName: 'C-Band Professional Services',
      companyEmail: 'accounts@c-band.com'
    };

    console.log('Sending test payment reminder to Emmanuel Sibanda...');
    const result = await emailService.sendPaymentReminder(reminderData);
    
    if (result) {
      console.log('✅ Test payment reminder sent successfully');
      return true;
    } else {
      console.error('❌ Failed to send test payment reminder');
      return false;
    }
  } catch (error) {
    console.error('❌ Error sending test payment reminder:', error);
    return false;
  }
}

// Function to send a test payment confirmation
export async function sendTestPaymentConfirmation() {
  try {
    const confirmationData = {
      invoiceNumber: 'INV-2024-001',
      clientName: 'Emmanuel Sibanda',
      clientEmail: 'emmanuel@sibanda.africa',
      amount: 2500.00,
      paymentMethod: 'Bank Transfer',
      paymentDate: new Date().toISOString(),
      companyName: 'C-Band Professional Services',
      companyEmail: 'accounts@c-band.com'
    };

    console.log('Sending test payment confirmation to Emmanuel Sibanda...');
    const result = await emailService.sendPaymentConfirmation(confirmationData);
    
    if (result) {
      console.log('✅ Test payment confirmation sent successfully');
      return true;
    } else {
      console.error('❌ Failed to send test payment confirmation');
      return false;
    }
  } catch (error) {
    console.error('❌ Error sending test payment confirmation:', error);
    return false;
  }
}
